import ImagePlaceholderTsoPq from '@components/ImagePlaceholder/ImagePlaceholderTsoPq';
import LoadingSpinnerTsoPq from '@components/LoadingSpinners/LoadingSpinnerTsoPq';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '@redux/hooks';
import {
  selectActiveTrend,
  selectDidUserApplyFilters,
  selectIsFetchingTredData,
  selectIsFiltering,
  selectTrendData,
} from '@redux/slices/trendIdentificationSlice';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledContent,
  StyledContentContainer,
  StyledContentTitle,
  StyledContentWrapper,
  StyledHeaderContainer,
  StyledIcon,
  StyledNoTrendContainer,
  StyledNoTrendDescriptionContainer,
  StyledNoTrendTitleContainer,
  StyledTableWrapper,
} from '../TrendIdentificationStyles';
import DataGrid from './ContentComponents/DataGrid';
import TrendCharts from './ContentComponents/TrendCharts';
import TrendTable from './ContentComponents/TrendTable';

const TrendIdentificationContent = () => {
  const trend = useAppSelector(selectActiveTrend);
  const isFetchingTrendData = useAppSelector(selectIsFetchingTredData);
  const isFiltering = useAppSelector(selectIsFiltering);
  const trendData = useAppSelector(selectTrendData);
  const didUserApplyFilters = useAppSelector(selectDidUserApplyFilters);

  const { t } = useTranslation();

  if (!trend.id) {
    return (
      <StyledContentWrapper>
        <StyledHeaderContainer>
          <StyledContentTitle>
            <TypographyTsoPq typographyType="pageTitleBold">{t('trendIdentification.content.title')}</TypographyTsoPq>
            <TypographyTsoPq typographyType="pageSubtitleSM">
              {t('trendIdentification.content.description')}
            </TypographyTsoPq>
          </StyledContentTitle>
        </StyledHeaderContainer>
        <StyledContent>
          <ImagePlaceholderTsoPq
            title={t('trendIdentification.placeholder.title')}
            description={t('trendIdentification.placeholder.description')}
          />
        </StyledContent>
      </StyledContentWrapper>
    );
  }

  let tableWrapperContent: JSX.Element;

  if (isFiltering) {
    tableWrapperContent = <LoadingSpinnerTsoPq />;
  } else if (trendData.length < 1 && didUserApplyFilters) {
    tableWrapperContent = (
      <StyledNoTrendContainer>
        <StyledNoTrendTitleContainer>
          <StyledIcon icon={faCircleExclamation} />
          <TypographyTsoPq typographyType="labelLGBold">{t('trendIdentification.filter.noData.title')}</TypographyTsoPq>
        </StyledNoTrendTitleContainer>
        <StyledNoTrendDescriptionContainer>
          <TypographyTsoPq typographyType="labelLG">
            {t('trendIdentification.filter.noData.description')}
          </TypographyTsoPq>
        </StyledNoTrendDescriptionContainer>
      </StyledNoTrendContainer>
    );
  } else {
    tableWrapperContent = <DataGrid />;
  }

  let mainContent: JSX.Element;

  if (isFetchingTrendData) {
    mainContent = <LoadingSpinnerTsoPq />;
  } else if (trendData.length < 1 && !didUserApplyFilters) {
    mainContent = (
      <>
        <StyledNoTrendContainer>
          <StyledNoTrendTitleContainer>
            <StyledIcon icon={faCircleExclamation} />
            <TypographyTsoPq typographyType="labelLGBold">
              {t('trednIdentification.tableContainer.noTrendFound.title')}
            </TypographyTsoPq>
          </StyledNoTrendTitleContainer>
          <StyledNoTrendDescriptionContainer>
            <TypographyTsoPq typographyType="labelLG">
              {t('trednIdentification.tableContainer.noTrendFound.decription1')}
            </TypographyTsoPq>
            <TypographyTsoPq typographyType="labelLG">
              {t('trednIdentification.tableContainer.noTrendFound.decription2')}
            </TypographyTsoPq>
          </StyledNoTrendDescriptionContainer>
        </StyledNoTrendContainer>
        <TrendTable noHeader />
      </>
    );
  } else {
    mainContent = (
      <StyledContentContainer>
        <TrendTable />

        <StyledTableWrapper sx={{ maxWidth: '79rem' }}>{tableWrapperContent}</StyledTableWrapper>

        {trendData.length > 0 && <TrendCharts />}
      </StyledContentContainer>
    );
  }

  return (
    <StyledContentWrapper>
      <StyledContent>
        <StyledHeaderContainer>
          <StyledContentTitle>
            <TypographyTsoPq typographyType="pageTitleBold">{t('trendIdentification.content.title')}</TypographyTsoPq>
            <TypographyTsoPq typographyType="pageSubtitleSM">
              {t('trendIdentification.content.description')}
            </TypographyTsoPq>
          </StyledContentTitle>
        </StyledHeaderContainer>

        {mainContent}
      </StyledContent>
    </StyledContentWrapper>
  );
};
export default TrendIdentificationContent;
